import type { InputHTMLAttributes } from "react";

export interface CheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, "type"> {
  label: string;
}

/** Checkbox with its label inside a 44px-tall target. Checked state is blue. */
export function Checkbox({ label, className = "", ...rest }: CheckboxProps) {
  return (
    <label
      className={`inline-flex min-h-11 cursor-pointer items-center gap-3 text-operate text-ink has-disabled:cursor-not-allowed has-disabled:text-ink-3 ${className}`}
    >
      <input type="checkbox" className="size-5 shrink-0 accent-blue" {...rest} />
      <span>{label}</span>
    </label>
  );
}
